module.exports = __webpack_public_path__ + "static/media/CTLI_7-315w.af168c4c.png";